
// Captures ad attribution (UTMs, gclid, landing URL, referrer) on the first page view of a
// session, so it survives the redirect to the thank-you page and goes into the lead payload.

const KEY = "onbbits_attribution";

const PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
];

export function captureAttribution() {
  try {
    if (sessionStorage.getItem(KEY)) return;

    const url = new URL(window.location.href);

    const data = {
      landing_url: url.href,
      referrer: document.referrer || undefined,
    };

    for (const p of PARAMS) {
      const v = url.searchParams.get(p);
      if (v) data[p] = v;
    }

    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // Storage blocked: attribution falls back to the current URL at submit time.
  }
}

export function getAttribution() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {
    // Ignore storage errors.
  }

  return {
    landing_url: window.location.href,
    referrer: document.referrer || undefined,
  };
}
